import React from 'react';
import {
    AssetsBackgroundImageBackToolTip,
    AssetsBackgroundImageFrontToolTip,
    AssetsClientLogoToolTip,
    AssetsFacebookImageToolTip,
    AssetsHomePageFeaturedToolTip,
    AssetsHomePageTrendingToolTip,
    AssetsHTMLFooterToolTip,
    AssetsMobileBreakHeaderToolTip,
    AssetsMobileClientLogoToolTip,
    AssetsMobileHTMLFooterToolTip,
    AssetsPinterestImageToolTip,
    AssetsReportHeaderToolTip
} from "components/break/tooltips/breaks-design-section-tool-tips";
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import {isMultiStepBreak, isNewLayout} from 'utils/break-utils';

export default {
    key: "breakPageSiteAssets",
    props: {
        headerKey: 'editbreak.section.design.heading'
    },
    fields: [
      {
          type: 'autoGenerateDesignImages'
      },
      {
        type: 'image',
        name: 'introImageId',
        idFor: 'introImage',
        showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored' && !isNewLayout(proxy.currentResource)),
        props: {
          labelKey: 'editbreak.design.introImageId',
          imageType: 'introImage'
        }
      },

      {
        type: 'image',
        name: 'introHeaderImageId',
        idFor: 'introHeaderImage',
        showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored' && !isNewLayout(proxy.currentResource)),
        props: {
          labelKey: 'editbreak.design.introHeaderImage',
          imageType: 'introHeaderImage'
        }
      },



        {
            type: 'image',
            name: 'backgroundImageId',
            idFor: 'backgroundImage',
            showField: (proxy) =>  (isMultiStepBreak(proxy.currentResource)  && !isNewLayout(proxy.currentResource)),
            props: {
                labelKey: 'editbreak.design.backgroundImageId',
                imageType: "backgroundWrapper",
                helpContent: <AssetsBackgroundImageFrontToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.backgroundImageId'}/></IntlProvider>,
            }
        },
        {
            type: 'image',
            name: 'backgroundTileImageId',
            idFor: 'backgroundTileImage',
            showField: (proxy) =>  (isMultiStepBreak(proxy.currentResource) && !isNewLayout(proxy.currentResource)),
            props: {
                labelKey: 'editbreak.design.backgroundTileImageId',
                imageType: "backgroundWrapper",
                helpContent: <AssetsBackgroundImageBackToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.backgroundTileImageId'}/></IntlProvider>,
            }
        },
        {
            type: 'image',
            name: 'sponsoredLogoId',
            idFor: 'sponsoredLogo',
            showField: (proxy) =>  (proxy.currentResource.sponsoredType === 'sponsored'),
            props: {
                labelKey: 'editbreak.design.sponsoredLogoId',
                imageType: 'clientLogo',
                helpContent: <AssetsClientLogoToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.sponsoredLogoId'}/></IntlProvider>
            }
        },
        {
            type: 'image',
            name: 'reportHeaderImageId',
            idFor: 'reportHeaderImage',
            showField: (proxy) =>  (proxy.currentResource.sponsoredType === 'sponsored'),
            linkedField: (formProxy) => ["sponsoredLogoId"],
            props: {
                labelKey: 'editbreak.design.report_header_image',
                imageType: 'clientLogo',
                helpContent: <AssetsReportHeaderToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.reportHeadrImageId'}/></IntlProvider>
            }
        },
        {
            type: 'image',
            name: 'mobileSponsoredLogoId',
            idFor: 'mobileSponsoredLogo',
            showField: (proxy) =>  (proxy.currentResource.sponsoredType === 'sponsored'),
            props: {
                labelKey: 'editbreak.design.mobileSponsoredLogoId',
                imageType: 'clientLogo',
                helpContent: <AssetsMobileClientLogoToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.mobileSponsoredLogoId'}/></IntlProvider>,
            }
        },
        {
            type: 'image',
            name: 'mobileMapHeaderImageId',
            idFor: 'mobileMapHeaderImage',
            showField: (proxy) =>  (isMultiStepBreak(proxy.currentResource)),
            props: {
                labelKey: 'editbreak.design.mobileMapHeaderImageId',
                imageType: 'mobileMapHeader',
                helpContent: <AssetsMobileBreakHeaderToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.mobileMapHeaderImageId'}/></IntlProvider>,
            }
        },
        {
            type: 'image',
            name: 'homepageHeroImage2024Id',
            idFor: 'homepageHeroImage2024',
            required: false,
            props: {
              labelKey: 'Homepage Hero Image ',
              imageType: 'custom',
              helperText: 'Asset should be 2080 x 940. It will be rendered at 1040 x 470.'
            }
        },
        {
            type: 'image',
            name: 'homepageMobileHeroImage2024Id',
            idFor: 'homepageMobileHeroImage2024',
            required: false,
            props: {
              labelKey: 'Homepage Mobile Hero Image ',
              imageType: 'custom',
              helperText: 'Asset should be 764 x 1000. It will be rendered at 382 x 500.'
            }
        },
        {
            type: 'image',
            name: 'homepage32Image2024Id',
            idFor: 'homepage32Image2024',
            required: true,
            props: {
              labelKey: 'Homepage 3:2 Image ',
              imageType: 'custom',
              helperText: 'Asset should be 666 x 444. It will be rendered at 333 x 222.'
            }
        },
        {
          type: 'image',
          name: 'heroImageId',
          idFor: 'heroImage',
          required: false,
          props: {
            labelKey: 'editbreak.design.heroImageId',
            imageType: 'heroCard'
          }
        },
        {
            type: 'image',
            name: 'cardImageId',
            idFor: 'cardImage',
            required: true,
            props: {
                labelKey: 'editbreak.design.cardImageId',
                imageType: 'cardTrending',
                helpContent: <AssetsHomePageTrendingToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.cardImageId'}/></IntlProvider>,
            }
        },
        {
            type: 'image',
            name: 'featuredImageId',
            idFor: 'featuredImage',
            required: true,
            props: {
                labelKey: 'editbreak.design.featuredImageId',
                imageType: 'featured',
                helpContent: <AssetsHomePageFeaturedToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.featuredImageId'}/></IntlProvider>,
            }
        },
        {
            type: 'image',
            name: 'socialShareBadgeId',
            idFor: 'socialShareBadge',
            required: true,
            props: {
                labelKey: 'editbreak.design.socialShareBadgeId',
                imageType: 'socialShare',
                helpContent: <AssetsFacebookImageToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.socialShareBadgeId'}/></IntlProvider>,
            }
        },
        {
            type: 'image',
            name: 'pinterestShareImageId',
            idFor: 'pinterestShareImage',
            props: {
                labelKey: 'editbreak.design.pinterestShareImageId',
                imageType: 'socialSharePinterest',
                helpContent: <AssetsPinterestImageToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.pinterestShareImageId'}/></IntlProvider>,
            }
        },
        {
            type: 'textarea',
            name: 'footerHtml',
            showField: (proxy) =>  (isMultiStepBreak(proxy.currentResource)),
            props: {
                labelKey: 'editbreak.design.footerHtml',
                helpContent: <AssetsHTMLFooterToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.footerHtml'}/></IntlProvider>,
            }
        },
        // {
        //     type: 'textarea',
        //     name: 'mobileFooterHtml',
        //     showField: (proxy) =>  (isMultiStepBreak(proxy.currentResource)),
        //     props: {
        //         labelKey: 'editbreak.design.mobileFooterHtml',
        //         helpContent: <AssetsMobileHTMLFooterToolTip/>,
        //         helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.design.mobileFooterHtml'}/></IntlProvider>,
        //     }
        // },
    ]
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksDesignSection.js